import axios from "axios"
import qs from "qs"

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['content-type'] = 'application/x-www-form-urlencoded'

// if(process.env.NODE_ENV != 'development') {
//     const host = window.location.hostname;
//     axios.defaults.baseURL = 'https://' + host + process.env.VUE_APP_BACKEND_URL
// } else {
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL
// }

export { axios, qs }
